// extracted by mini-css-extract-plugin
module.exports = {"ForumSearch__headline":"qi_a bhp_rh bhp_tu","ForumSearch__img":"qi_b","ForumSearch__searchAdsAndShoppingAds":"qi_c","ForumSearch__results--empty":"qi_e"};